var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGiver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 29.613 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.323 3.643h-6.737a4.957 4.957 0 00-9.56 0H3.29A3.274 3.274 0 000 6.881v23.881A3.274 3.274 0 003.29 34h23.033a3.274 3.274 0 003.29-3.238V6.881a3.274 3.274 0 00-3.29-3.238zm-11.516 0a1.619 1.619 0 11-1.645 1.619 1.637 1.637 0 011.644-1.619zm11.721 27.321H3.085V6.679H6.17v5.464h17.274V6.679h3.085z",
    fill: "#bbb"
  })));
}

export default SvgIconGiver;